import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import terminology from 'javascripts/terminology';
import { promotedRecordQuery } from './PromotedRecordQuery';

export class PromotedRecordType extends Field {
  static subqueriesForModel() {
    return {
      promotable: promotedRecordQuery(),
    };
  }

  get title() {
    return 'Promoted to record type';
  }

  exampleContents(): FieldContentsData {
    return { text: terminology('Feature') };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.promotable) {
      return {
        text: terminology(record.promotable.typename),
      };
    }

    return {};
  }
}
